import script from "./PasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./PasswordPage.vue?vue&type=style&index=0&id=e6d6ee1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6d6ee1e"]])

export default __exports__